<a [routerLink]="['/consultations']" routerLinkActive="active">
  <span class="text">{{ 'Мои консультации' | translate }}</span>
</a>
